module.exports = __webpack_public_path__ + "img/no-photo.8111930d.svg";